/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { WalletconnectModule } from "@vlinder-web/walletconnect-module-react";

const MODULE_NAME = "MyWalletService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class MyWalletService {
    private static instance: MyWalletService;
    private vapp: VApplication;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
    }
    public static getInstance(props: any = {}): MyWalletService {
        if (!MyWalletService.instance) {
            MyWalletService.instance = new MyWalletService(props);
        }
        return MyWalletService.instance;
    }

    async verifySignature(signature: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("api-gateway");
        try {
            // if (client) {
            //             const res = await client.query({
            //                 query: GET_ASSET_DETAIL,
            //                 variables: {
            //                     tokenId:assetId,
            //                     storeId:"61739cbd2fbe0a187c984fb6"
            //                 },
            //             });
            // }
            return true;
        } catch (err: any) {
            return err;
        }
    }
}
